import {
  Client,
  Locale,
  Account,
  Databases,
  Query,
  Storage,
  Teams,
} from "appwrite";
import { environment } from "src/environments/environment";

export const client = new Client();

client.setEndpoint(environment.endpoint).setProject(environment.projectID); // Replace with your project ID

export const account = new Account(client);
export const databases = new Databases(client);
export const storage = new Storage(client);
export const teams = new Teams(client);

export const locale = new Locale(client);

export { ID } from "appwrite";
